import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';
import type { SiteSettings } from '../types';

const videoTypeFor = (url: string) => (/\.mov($|\?)/i.test(url) ? 'video/quicktime' : 'video/mp4');

type VideoKey = keyof Pick<SiteSettings, 'hero_video_url' | 'hero_video_home' | 'hero_video_about' | 'hero_video_contact' | 'hero_video_management' | 'hero_video_properties'>;

interface Props {
  height?: string;
  overlay?: string;
  videoKey?: VideoKey;
  children: React.ReactNode;
}

export default function VideoHero({
  height = 'h-[400px]',
  overlay = 'bg-black bg-opacity-60',
  videoKey = 'hero_video_url',
  children,
}: Props) {
  const [video, setVideo] = useState<string>('');
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let active = true;
    api
      .get<Partial<SiteSettings>>('/settings')
      .then((s) => {
        if (!active) return;
        if (s[videoKey]) setVideo(s[videoKey]);
        setReady(true);
      })
      .catch(() => {
        if (active) setReady(true);
      });
    return () => {
      active = false;
    };
  }, [videoKey]);

  return (
    <section className={`relative overflow-hidden ${height}`}>
      {ready && video ? (
        <video
          className="absolute inset-0 w-full h-full object-cover"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
        >
          <source src={video} type={videoTypeFor(video)} />
        </video>
      ) : null}
      <div className={`absolute inset-0 ${overlay}`} />
      <div className="relative h-full">{children}</div>
    </section>
  );
}
